var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { class: _vm.$style.form },
    [
      _c("LoginTextField", {
        attrs: {
          label: "Password",
          name: "password",
          placeholder: "Password",
          type: "password",
          vvName: "password",
          rules: _vm.passwordFieldValidation,
          submitOnEnter: _vm.submit,
        },
        model: {
          value: _vm.form.password,
          callback: function ($$v) {
            _vm.$set(_vm.form, "password", $$v)
          },
          expression: "form.password",
        },
      }),
      _vm._v(" "),
      _c("LoginTextField", {
        attrs: {
          label: "Confirm Password",
          name: "confirm password",
          placeholder: "Confirm Password",
          type: "password",
          vvName: "confirm password",
          rules: _vm.confirmPasswordFieldValidation,
          submitOnEnter: _vm.submit,
        },
        model: {
          value: _vm.form.confirm,
          callback: function ($$v) {
            _vm.$set(_vm.form, "confirm", $$v)
          },
          expression: "form.confirm",
        },
      }),
      _vm._v(" "),
      _vm.clientType === "admin"
        ? _c("div", { class: _vm.$style.termsOfUse }, [
            _c("div", { class: _vm.$style.terms }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.license,
                    expression: "form.license",
                  },
                ],
                class: _vm.$style.licenseInput,
                attrs: {
                  "data-vv-name": "Terms of Use",
                  name: "Terms of Use",
                  required: "",
                  type: "checkbox",
                },
                domProps: {
                  checked: Array.isArray(_vm.form.license)
                    ? _vm._i(_vm.form.license, null) > -1
                    : _vm.form.license,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.form.license,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.form, "license", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "license",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "license", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v("\n        I agree to the\n        "),
                _c(
                  "a",
                  {
                    class: _vm.$style.resetPasswordLink,
                    attrs: {
                      href: "https://jumpcloud.com/legal",
                      rel: "noopener noreferrer",
                      target: "_blank",
                    },
                  },
                  [_vm._v("Terms of Use")]
                ),
              ]),
              _vm._v(" "),
              _vm.errors.has("Terms of Use")
                ? _c("div", { class: _vm.$style.errorDisplay }, [
                    _c("i", { class: _vm.$style.errorDisplayPointer }),
                    _vm._v(" "),
                    _c("i", {
                      class: ["jc-actions-alert", _vm.$style.removeIcon],
                    }),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "LoginActionButton",
        {
          attrs: {
            action: _vm.submit,
            isLoading: _vm.isLoading,
            disabled: _vm.disabled,
          },
        },
        [_vm._v("\n    Reset Password\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }